import { render, staticRenderFns } from "./Racks.vue?vue&type=template&id=3156cd36&scoped=true&"
import script from "./Racks.vue?vue&type=script&lang=js&"
export * from "./Racks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156cd36",
  null
  
)

export default component.exports